import React from "react";

const About = () => (
  <section id="about" className="py-16 bg-gray-100 dark:bg-gray-800">
    <div className="container mx-auto px-4 flex flex-col md:flex-row items-center gap-8">
      <div className="md:w-1/2">
        <h2 className="text-3xl font-bold mb-4 text-gray-800 dark:text-gray-100">About Me</h2>
        <p className="text-gray-700 dark:text-gray-300">
          I am a BCA student with hands-on experience in Python, SQL, ETL pipelines, and Machine Learning. I have built impactful data solutions including Social Media ETL pipelines, Weather Data Pipeline automation using Airflow, and ML pipelines. I also co-founded the Cognito IT Club and led tech events like DAV Code Fest. My goal is to deliver high-quality data-driven solutions as a Data Engineer or Analyst.
        </p>
      </div>
      <div className="md:w-1/2 flex justify-center">
        <div className="w-48 h-48 bg-gray-300 dark:bg-gray-700 rounded-full shadow-lg"><img src="/profile.jpg" alt="" /></div>
      </div>
    </div>
  </section>
);

export default About;